import React from "react"

export const AIIcon = ({ style }: { style?: React.CSSProperties }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="22" viewBox="0 0 27 22" fill="none" style={{ cursor: "pointer", ...style }}>
        <rect x="0.166992" y="0.806641" width="26.3327" height="20.3866" rx="4" fill="#9747FF" fillOpacity="0.2" />
        <path
            d="M16.5689 5.71441L17.1254 4.04492H18.0924L18.6489 5.71441L20.3184 6.27091V7.23793L18.6489 7.79442L18.0924 9.46391H17.1254L16.5689 7.79442L14.8994 7.23793V6.27091L16.5689 5.71441Z"
            fill="#9747FF"
        />
        <path d="M18.4583 11.0016V16.9477H16.7595V11.0016H18.4583Z" fill="#9747FF" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.40101 5.90497H12.2257L15.0886 16.9477H13.3335L12.6729 14.3994H8.95381L8.29314 16.9477H6.53809L9.40101 5.90497ZM9.39426 12.7005H12.2324L10.9111 7.60386H10.7156L9.39426 12.7005Z"
            fill="#9747FF"
        />
    </svg>
)
